import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrandingService } from '@feature/branding';

@Component({
  selector: 'ui-powered-by-carepay',
  templateUrl: './powered-by-carepay.component.html',
  styleUrls: ['./powered-by-carepay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIPoweredByCarepayComponent {
  private readonly brandingService: BrandingService = inject(BrandingService);

  protected readonly poweredBySrc: string = `/assets/icon/${this.brandingService.branding().poweredBySvg}`;
}
